import React from 'react';

interface IcoVkProps {
    size?: number;
}

export const IcoVk: React.FC<IcoVkProps> = ({ size = 22 }) => {
    const wrapperStyle: React.CSSProperties = {
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center',
        width: `${size}px`,
        height: `${size}px`,
    };

    return (
        <div style={wrapperStyle}>
            <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" width={size} height={size}>
                <g fill="none" opacity=".6">
                    <circle cx="11.92" cy="11.92" r="10" fill="#605F68" />
                    <path
                        fill="#F1F1F1"
                        d="M11.92 1.92c5.523 0 10 4.477 10 10s-4.477 10-10 10-10-4.477-10-10 4.477-10 10-10zm5.809 7.006c.084-.281 0-.489-.401-.489h-1.332c-.339 0-.493.179-.58.376 0 0-.675 1.65-1.635 2.722-.31.31-.453.409-.62.409-.084 0-.212-.099-.212-.379V8.93c0-.339-.095-.489-.376-.489h-2.091c-.212 0-.339.157-.339.307 0 .321.478.394.529 1.296v1.96c0 .431-.077.507-.248.507-.453 0-1.547-1.657-2.201-3.555-.128-.369-.256-.519-.595-.519H6.295c-.379 0-.456.179-.456.376 0 .354.453 2.102 2.102 4.412 1.098 1.58 2.649 2.434 4.058 2.434.847 0 .949-.19.949-.518v-1.193c0-.38.08-.456.347-.456.197 0 .536.099 1.325.861.901.901 1.051 1.306 1.558 1.306h1.332c.38 0 .569-.19.46-.566-.12-.372-.551-.916-1.124-1.558-.31-.365-.774-.763-.916-.96-.197-.255-.142-.365 0-.591 0 0 1.62-2.285 1.792-3.058h.007z"
                    />
                </g>
            </svg>
        </div>
    );
};
